module.exports = __webpack_public_path__ + "img/qy_3.c36622dc.png";